<template>
    <div class="wrap">
        <div class="wrap-fixed">
            <span >
                <img src="@/assets/img/404.png" width="600" alt="">
            </span>
        </div>
    </div>

</template>

<script>

    export default {
        name: "error"
    };
</script>

<style scoped>
    .wrap{
        left: 0;
        top: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        background: #6d98ed;
    }
    .wrap-fixed{
        position: absolute;
        width: 600px;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
</style>